import { OpportunitiesContext } from 'pages/Opportunities/context/OpportunitiesContext';
import React, { Fragment, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useContextSelector } from 'use-context-selector';
import Applied from './Applied/Applied';

import { Hidden, Tab } from '@material-ui/core';
import { CustomTypography } from 'shared/elements/CustomTypography';
import NotInterested from './NotInterested/NotInterested';
import New from './New/New';
import { ActiveTabContainer, HideFilterButton, TabContainer, TabHeader, TabLabelCont } from './OpportunitiesTab.styles';
import { useTabAggregates } from './useTabAggregates';
import { LoadingSpinnerIconTwoTone, StyledTooltip } from '@room-match/shared-ui-components';
import { ls } from 'shared/utils/ls';
import { opportunitiesDefaultStates } from 'pages/Opportunities/context/OpportunitiesDefaultStates';
import { opportunitiesServices } from 'shared/services/opportunitiesServices';
const { checkAutidion } = opportunitiesServices();

const OpportunitiesTab = () => {
  const { getLS, removeLS } = ls();
  const hasPendingApplication = getLS('pending_job_application');
  const { projectId, roleId } = useParams() as { projectId: string; roleId: string };
  const { data: checkResult, isLoading: isChecking } = checkAutidion(roleId);
  const history = useHistory();
  const { tabs, tabIsLoading } = useTabAggregates();
  // const { tab: tabURL } = useParams() as { tab: 'new' | 'applied' | 'not_interested' };
  const [tab, settab] = useState<'new' | 'submitted' | 'not_interested'>('new');

  const setHideFilter = useContextSelector(OpportunitiesContext, (state) => state.setHideFilters);
  const hideFilters = useContextSelector(OpportunitiesContext, (state) => state.hideFilters);
  const openOpportunityModal = useContextSelector(OpportunitiesContext, (state) => state.openOpportunityModal);
  const setFilters = useContextSelector(OpportunitiesContext, (state) => state.setFilters);
  const setOnlyFilters = useContextSelector(OpportunitiesContext, (state) => state.setOnlyFilters);

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: 'new' | 'submitted' | 'not_interested') => {
    //remove adding tab to url , causes page to reload and rerender the page
    // history.push(`${ROUTES.TALENT.OPPORTUNITIES}/${newValue}`);
    // setFilters({ tab_filter: newValue });
    settab(newValue);
  };

  // useEffect(() => {
  //   console.log('OpportunitiesTab Rendered', tab);
  // });

  useEffect(() => {
    if (isChecking) return;
    if (projectId && roleId && hasPendingApplication) {
      if (checkResult?.data) {
        openOpportunityModal('already_submitted');
        removeLS('pending_job_application');
      } else {
        openOpportunityModal('continue_application');
        if (projectId && roleId) {
          setOnlyFilters({
            //add defalut filters
            // ...opportunitiesDefaultStates.filters,
            // countries: '',
            project_ids: [projectId],
            role_ids: [roleId],
          });
        }
      }
    }
  }, [projectId, roleId, hasPendingApplication, isChecking, checkResult]);

  return (
    <TabContainer>
      <TabHeader value={tab || 'new'} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={
              <TabLabelCont>
                <CustomTypography fontSize={14} fontWeight={700}>
                  {tab.header}
                </CustomTypography>
                {tabIsLoading ? (
                  <StyledTooltip title={`Fetching ${tab.header} tab count`}>
                    <TabLabelCont style={{ marginLeft: -5, marginRight: -10 }}>
                      <LoadingSpinnerIconTwoTone style={{ width: 25, height: 25 }} />
                    </TabLabelCont>
                  </StyledTooltip>
                ) : (
                  <CustomTypography fontSize={14} fontWeight={700} color="primary">
                    {tab.count}
                  </CustomTypography>
                )}
              </TabLabelCont>
            }
            disabled={tab.count === 0}
            value={tab.name}
            style={{ textTransform: 'capitalize' }}
          />
        ))}
      </TabHeader>
      <ActiveTabContainer>
        <New show={tab === 'new'} />
        <Applied show={tab === 'submitted'} />
        <NotInterested show={tab === 'not_interested'} />
      </ActiveTabContainer>
      {tab !== 'submitted' && tab !== 'not_interested' && !projectId ? (
        <Hidden smDown>
          <HideFilterButton variant="outlined" color="primary" onClick={setHideFilter}>
            <CustomTypography fontSize={12}>{hideFilters ? 'Show Filters' : 'Hide Filters'}</CustomTypography>
          </HideFilterButton>
        </Hidden>
      ) : (
        <Fragment />
      )}
    </TabContainer>
  );
};

export default React.memo(OpportunitiesTab);
